import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyPage from "./PolicyPage";
import "../css/returns.scss";

function Returns() {
  const returnWindow = siteConfig.shipping.returnsWindowDays;
  const sections = [
    {
      id: "window",
      title: "Return window",
      paragraphs: [
        `Eligible items may be returned within ${returnWindow} calendar days of delivery. A return must be requested before the window closes and sent back promptly using the instructions provided by customer care.`,
        "Any mandatory cancellation or consumer rights available in your location continue to apply and may provide different time limits or remedies.",
      ],
    },
    {
      id: "eligibility",
      title: "Return condition",
      paragraphs: [
        "Try garments with care. Returned pieces must be unworn beyond a normal fitting, unwashed, unaltered and free from scent, marks and pet hair, with their original labels attached and protective packaging included.",
      ],
      items: [
        "Final-sale items are returnable only where consumer law requires it.",
        "Gift cards and personalised or altered pieces cannot normally be returned.",
        "For hygiene reasons, opened care products or worn intimate accessories cannot normally be accepted.",
      ],
    },
    {
      id: "start",
      title: "How to request a return",
      paragraphs: [
        `Email ${siteConfig.contact.email} with your order number, the items you wish to return and the reason for your request. We will reply with the applicable return address and packing instructions.`,
        "Do not send items to the studio address without authorisation. Use a tracked service and retain the receipt until the return is complete, as responsibility for an independently posted parcel remains with the sender until it reaches the return location.",
      ],
    },
    {
      id: "refunds",
      title: "Inspection and refunds",
      paragraphs: [
        "We will inspect an authorised return after it arrives. An approved refund is issued to the original payment method, normally within 5–10 working days of inspection. Your bank or card provider may take additional time to display it.",
        "Original standard delivery charges are refunded only where required by law. Express upgrades and return postage are normally excluded. If an item is returned outside the policy or in a diminished condition, the refund may be declined or reasonably reduced where permitted.",
      ],
    },
    {
      id: "exchanges",
      title: "Exchanges",
      paragraphs: [
        "Because quantities are intentionally limited, direct exchanges are not reserved. The clearest route is to return the original piece and place a separate order for the preferred size or colour. Each transaction is assessed independently.",
      ],
    },
    {
      id: "faults",
      title: "Incorrect, damaged or faulty items",
      paragraphs: [
        "Contact customer care promptly if the wrong item arrives or a piece appears damaged or faulty. Include the order number and photographs of the garment, labels and parcel. Do not arrange a return until instructions are provided; reasonable return costs for a confirmed issue will be covered. This policy does not limit statutory remedies.",
      ],
    },
  ];

  return (
    <div className="returns">
      <PolicyPage
        title="Returns"
        intro={`A considered returns process for pieces ordered from ${siteConfig.brandName}.`}
        sections={sections}
        relatedLinks={[
          { label: "Shipping", to: "/shipping" },
          { label: "Contact customer care", to: "/contact" },
          { label: "Terms", to: "/terms" },
        ]}
      />
    </div>
  );
}

export default Returns;
